import { useEffect, useState } from "react";

export const ScrollBlock = ({ ...props }) => {
  const [currentHash, setCurrentHash] = useState(() => {
    if (typeof window !== "undefined") {
      return window.location.hash;
    }
    return "";
  });

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };
    if (typeof window !== "undefined") {
      // Добавляем слушатель события изменения хэша
      window.addEventListener("hashchange", handleHashChange);

      // Обработаем текущий хэш при монтировании компонента
      handleHashChange();

      // Удаляем слушатель при размонтировании компонента
      return () => {
        window.removeEventListener("hashchange", handleHashChange);
      };
    }
  }, []);

  useEffect(() => {
    if (currentHash) {
      const blockId = currentHash.slice(1);
      const targetBlock = document.getElementById(blockId);
      if (targetBlock) {
        targetBlock.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [currentHash]);

  return null;
};
